






























































































































































































































































































































































































import {
  defineComponent,
  computed,
  ref,
  useContext,
  useRouter,
  nextTick,
  onMounted
} from '@nuxtjs/composition-api'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'
import UserAuthService from '~/services/login/UserAuthService'
import { useI18n } from '~/compositions/i18n'
import CInternationalTelephoneInput from '~/components/shared/configurable/form/input/CInternationalTelephoneInput.vue'
import CInternationalPostcodeInput from '~/components/shared/configurable/form/input/CInternationalPostcodeInput.vue'
import CMapLocationInput from '~/components/shared/configurable/location/CMapLocationInput.vue'
import { FullLocation } from '~/models/google'
import { faCheckCircle, faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import CEmailInput from '~/components/shared/configurable/form/input/CEmailInput.vue'
import CBreadcrumbs from '~/components/shared/configurable/CBreadcrumbs.vue'
import ScrollService from '~/services/scroll/ScrollService'
import { handleError } from '~/utils/http'
import RecaptchaService from '~/services/recaptcha/RecaptchaService'
import CRecaptchaText from '~/components/shared/configurable/CRecaptchaText.vue'
import CCustomSelect from '~/components/shared/configurable/form/select/custom/CCustomSelect.vue'
import {
  FallbackWidgetRenderResult,
  RecaptchaFormToken
} from '~/models/recaptcha/types'
import { HttpStatus } from '~/constants/http'
import { toCamelCase } from '~/utils/object'
import { AgentSettingsSchema } from '~/models/account'

export default defineComponent({
  components: {
    CFormError,
    CInternationalTelephoneInput,
    CInternationalPostcodeInput,
    CMapLocationInput,
    CCustomSelect,
    CEmailInput,
    CBreadcrumbs,
    CRecaptchaText
  },
  setup() {
    const { t } = useI18n()
    const router = useRouter()
    const { $dep, $logger, $snackbar } = useContext()
    const userAuthService = $dep(UserAuthService)
    const scrollService = $dep(ScrollService)
    const recaptchaService: RecaptchaService = $dep(RecaptchaService)

    const schema = ref<AgentSettingsSchema>({} as AgentSettingsSchema)
    const isModalVisible = ref(false)
    const loading = ref(false)
    const breadcrumbs = [
      {
        text: t('agent registration')
      }
    ]
    const fields = ref({
      name: null,
      username: null,
      telephone1: null,
      telephone2: null,
      address: null,
      postcode: {
        postcode: {
          name: ''
        },
        country: {
          id: 1
        }
      },
      pagePath: null,
      agentLicenseNumber: null,
      technicalEmail: null,
      agentType: 'realtor',
      acceptedTerms: false,
      agentCode: '',
      geolocation: null
    })

    const fieldsState = ref({
      usernameState: null,
      technicalEmailState: null,
      telephone1State: null,
      telephone2State: null
    })

    const recaptchaToken = ref(null)
    const showRecaptcha2 = ref(false)
    const recaptcha2Loaded = ref(false)
    const invalidRecaptchaToken = ref(false)

    const errors = ref({
      telephone1Error: null,
      telephone2Error: null,
      pagePathError: null,
      nameError: null,
      usernameError: null,
      agentTypeError: null,
      agentCodeError: null,
      addressError: null,
      postcodeError: null,
      technicalEmailError: null,
      acceptedTermsError: null
    })

    const errorsWithIdsMapper = {
      nameError: 'name',
      usernameError: 'username',
      telephone1Error: 'telephone1',
      telephone2Error: 'telephone2',
      addressError: 'address',
      pagePathError: 'pagePath',
      agentTypeError: 'agentType',
      agentCodeError: 'agentCode',
      technicalEmailError: 'technicalEmail',
      acceptedTermsError: 'acceptedTerms'
    }

    onMounted(async () => {
      scrollService.scrollToTop({ duration: 0 })
      await fetchAgentRegistrationData()
    })

    const agentTypeOptions = computed(() => {
      return schema.value.agentType?.options.map(option => ({
        value: option.value,
        text: option.label
      }))
    })

    const icons = computed(() => ({
      info: faInfoCircle,
      check: faCheckCircle
    }))
    const handleHideModal = () => {
      isModalVisible.value = false
      router.push({ path: '/' })
    }

    const fetchAgentRegistrationData = async () => {
      loading.value = true
      try {
        const {
          schema: schemaData
        } = await userAuthService.fetchAgentRegistrationData()
        schema.value = schemaData
      } catch (error) {
        $logger.captureError(error)
        $snackbar.error(t('an error occurred please try again later'))
      } finally {
        loading.value = false
      }
    }

    const docsText = computed(() => {
      const translation = t(
        'for bulk offer/management of classifieds through our api, you can find more information at www.plot.gr/docs/ or contact one of'
      )
      const docsUrlWithTags =
        '<a href="https://www.plot.gr/docs/" alt="plot docs">www.plot.gr/docs</a>'

      return translation.replace('www.plot.gr/docs/', docsUrlWithTags)
    })

    const requiredFields = computed(() => {
      const keys = Object.keys(schema.value)
      const requiredFields: Array<string> = []
      if (keys.length) {
        keys.forEach((k: string) => {
          if (schema.value[k].required && !['recaptchaToken'].includes(k)) {
            requiredFields.push(k)
          }
        })

        return requiredFields
      }

      return null
    })

    const onRecaptchaError = async () => {
      if (!showRecaptcha2.value) {
        showRecaptcha2.value = true
        if (!recaptcha2Loaded.value) {
          recaptcha2Loaded.value = true
          await nextTick()

          const {
            token
          }: FallbackWidgetRenderResult = await recaptchaService.renderFallbackWidget(
            'g-recaptcha'
          )
          scrollToRecaptcha()
          recaptchaToken.value = {
            v: 2,
            token
          } as RecaptchaFormToken
        } else {
          await recaptchaService.reset()
          scrollToRecaptcha()
        }
      }
    }

    const scrollToRecaptcha = () => {
      scrollService.scrollTo(document.getElementById('recaptchaWrapper'), {
        duration: 300,
        easing: 'ease-out',
        offset: -100
      })
    }
    const handleUnprocessableEntity = err => {
      if (err.recaptchaToken) {
        invalidRecaptchaToken.value = recaptchaToken.value
        onRecaptchaError()
      } else {
        const errorKeys = Object.keys(err)
        errorKeys.forEach(e => {
          errors.value[`${e}Error`] = err[e]
        })
        scrollToInvalid()
      }
    }

    const scrollToInvalid = async () => {
      await nextTick()
      const keys = Object.keys(errorsWithIdsMapper)
      const errorKey = keys.find(k => errors.value[k] !== null)
      const id = errorsWithIdsMapper[errorKey]
      scrollService.scrollTo(document.getElementById(id), {
        duration: 300,
        easing: 'ease-out',
        offset: -100
      })
    }
    const handleSubmitAgentData = async () => {
      if (validateFields()) {
        loading.value = true
        try {
          if (!showRecaptcha2.value) {
            const token = await recaptchaService.getToken('agents_register')
            recaptchaToken.value = {
              v: 3,
              token
            }
          }

          await userAuthService.createAgent({
            ...fields.value,
            recaptchaToken: recaptchaToken.value
          })
          isModalVisible.value = true
          showRecaptcha2.value = false
        } catch (error) {
          if (error?.response?.status === HttpStatus.UNPROCESSABLE_ENTITY) {
            handleUnprocessableEntity(
              toCamelCase(error?.response?.data?.data?.errors)
            )
          }
          handleError(error, $snackbar, $logger, t)
        } finally {
          loading.value = false
        }
      } else {
        scrollToInvalid()
      }
    }
    const isFieldEmpty = (field: string) => {
      const fieldValue = fields.value[field]
      return !fieldValue || fieldValue?.toString()?.length === 0
    }

    const isCustomField = (field: string) => {
      return [
        'username',
        'technicalEmail',
        'telephone1',
        'telephone2'
      ].includes(field)
    }

    const handeTelephoneValidation = (field: string, value: boolean) => {
      validateCustomFields(field, value, t('invalid phone number'))
    }

    const handleEmailValidation = (field: string, value: boolean) => {
      validateCustomFields(field, value, t('please enter a valid email'))
    }

    const validateFields = () => {
      const validFields: Array<boolean> = []
      requiredFields.value.forEach(field => {
        validFields.push(validateInput(field))
      })
      return !validFields.some(f => !f)
    }

    const validateCustomFields = (
      field: string,
      value: boolean,
      message: string
    ) => {
      const isRequired = requiredFields?.value?.includes(field)
      const isEmpty = isFieldEmpty(field)
      if (
        (isRequired && !isEmpty && !value) ||
        (!isRequired && !isEmpty && !value)
      ) {
        errors.value[`${field}Error`] = message
        fieldsState.value[`${field}State`] = false
      } else {
        errors.value[`${field}Error`] = null
        fieldsState.value[`${field}State`] = null
      }
    }

    const validateAddress = (
      address: string,
      postcode: string,
      geolocation: object,
      ignorePostcode: boolean = false
    ) => {
      const field = 'address'
      let isEmpty
      if (!address || (address?.length === 0 && ignorePostcode)) {
        isEmpty = true
      } else if (!address || (address?.length === 0 && !ignorePostcode)) {
        isEmpty = !address || address?.length === 0 || !postcode
      }
      if (geolocation && !isEmpty) {
        errors.value[`${field}Error`] = null
      } else if (isEmpty) errors.value[`${field}Error`] = t('invalid address')
    }

    const validateAgentPage = () => {
      const regex = new RegExp(
        '^[a-zA-Z0-9]{1,}-?[a-zA-Z0-9]*-?[a-zA-Z0-9]*-?[a-zA-Z0-9]*-?[a-zA-Z0-9]*-?[a-zA-Z0-9]{1,}$'
      )
      if (!fields.value.pagePath?.match(regex)) {
        errors.value.pagePathError = t('invalid page path')
        return false
      }
      errors.value.pagePathError = null
      return true
    }

    const validateInput = (field: string) => {
      const isRequired = requiredFields?.value?.includes(field)
      const isEmpty = isFieldEmpty(field)
      if (field === 'pagePath' && !isEmpty) {
        return validateAgentPage()
      } else if (isRequired && isEmpty) {
        errors.value[`${field}Error`] = t('this field is required')
        if (isCustomField(field)) {
          fieldsState.value[`${field}State`] = false
          return false
        }
        return false
      } else if ((!isRequired && isEmpty) || (isRequired && !isEmpty)) {
        errors.value[`${field}Error`] = null
        return true
      }
    }

    const handleLocationChange = (data: FullLocation) => {
      fields.value.geolocation = data.geolocation
    }

    const handleTermsChange = (val: boolean) => {
      fields.value.acceptedTerms = val
      validateInput('acceptedTerms')
    }

    return {
      fields,
      fieldsState,
      loading,
      schema,
      errors,
      icons,
      agentTypeOptions,
      breadcrumbs,
      isModalVisible,
      showRecaptcha2,
      handleLocationChange,
      handleSubmitAgentData,
      validateInput,
      handleEmailValidation,
      handeTelephoneValidation,
      validateAddress,
      handleTermsChange,
      handleHideModal,
      docsText
    }
  },

  methods: {}
})
